var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5872 4.24497L9.49068 2.29336C8.58893 1.75472 7.46656 1.74517 6.55575 2.26836L2.4131 4.24497C2.39755 4.25276 2.38143 4.26109 2.36643 4.26997C1.38333 4.8321 1.04204 6.08475 1.60416 7.06785C1.7947 7.40112 2.07498 7.67419 2.4131 7.856L3.55585 8.40044V11.1226C3.55653 12.3398 4.34857 13.4152 5.5108 13.777C6.31961 14.011 7.15826 14.1255 8.00019 14.117C8.842 14.1264 9.68065 14.0128 10.4896 13.7798C11.6518 13.418 12.4439 12.3426 12.4445 11.1254V8.39932L13.5556 7.86822V12.4503C13.5556 12.7571 13.8043 13.0058 14.1112 13.0058C14.418 13.0058 14.6667 12.7571 14.6667 12.4503V5.78382C14.6704 5.13146 14.1553 4.52882 13.5872 4.24497ZM11.3334 11.1254C11.3337 11.8535 10.8613 12.4975 10.1668 12.7159C9.46247 12.9171 8.73262 13.0148 8.00017 13.0059C7.26771 13.0148 6.53786 12.9171 5.83356 12.7159C5.13902 12.4974 4.66663 11.8535 4.66692 11.1254V8.92988L6.50966 9.80765C6.96433 10.0776 7.48362 10.2195 8.01241 10.2182C8.51573 10.2218 9.01058 10.0885 9.44404 9.83265L11.3334 8.92986V11.1254ZM13.1112 6.85324L8.92126 8.85319C8.33706 9.19337 7.61294 9.18373 7.03798 8.82819L2.93863 6.87824C2.48169 6.63184 2.31102 6.06167 2.55742 5.60476C2.64075 5.45023 2.76569 5.32213 2.91808 5.23495L7.08186 3.24612C7.66624 2.9067 8.38998 2.91631 8.96514 3.27112L13.0617 5.22274C13.363 5.39002 13.5515 5.70593 13.5556 6.0505C13.5561 6.3769 13.3881 6.68043 13.1112 6.85324Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.8d1f65715852caf406325f50894feabf.svg";
export { ForwardRef as ReactComponent };